import {Router} from 'react-router-dom';
import './config/ReactotronConfig';
import Routes from './routes';
import history from  './services/history';
import { AuthProvider } from './hooks/Auth';
import { Toaster } from 'react-hot-toast';
import { GoogleOAuthProvider } from '@react-oauth/google';


export function App() {
  return (
    <GoogleOAuthProvider clientId="696958825806-hnsv5i0et1qh5ga12g26hstkp49kvc4d.apps.googleusercontent.com">
      <AuthProvider>
        <Router history={history} >
          <Routes />
        </Router>
      </AuthProvider>
      <Toaster />
    </GoogleOAuthProvider>
  );
}


